export default __webpack_public_path__ + "static/media/profile-torik.7f0b699c.png";